const QA_SCROLL_SEED_PREFIX_PATTERN = /^QA_SCROLL_[A-Z0-9_]+$/

const firstNonEmptyString = values =>
    values.find(value => typeof value === 'string' && value.trim().length > 0) || ''

const normalizeCase = value => String(value || '').replace(/-/g, '_')

export const parseQaScrollSeedAnswer = answer => {
    const text = firstNonEmptyString([
        answer?.content,
        answer?.display_content,
        answer?.content_preview,
    ])
    const firstLine = text.split(/\r?\n/, 1)[0]?.trim()
    if (!firstLine) return null

    const [prefix, ...tokens] = firstLine.split(/\s+/)
    if (!QA_SCROLL_SEED_PREFIX_PATTERN.test(prefix) || tokens.length < 2) return null

    const rawRole = tokens[0]
    const rawCase = tokens[tokens.length - 1]
    const indexTokens = tokens.slice(1, -1)
    const numericLeadingToken = /^\d+$/.test(rawRole)

    return {
        prefix,
        role: numericLeadingToken ? 'row' : rawRole,
        index: numericLeadingToken && indexTokens.length === 0 ? rawRole : indexTokens.join(' '),
        case: normalizeCase(rawCase),
    }
}

export const qaScrollSeedDataAttributes = (
    answer,
    { surface = null, virtualized = false } = {},
) => {
    const metadata = parseQaScrollSeedAnswer(answer)
    if (!metadata) return {}

    return {
        'data-qa-scroll-seed': metadata.prefix,
        'data-qa-scroll-role': metadata.role,
        'data-qa-scroll-index': metadata.index,
        'data-qa-scroll-case': metadata.case,
        'data-qa-scroll-surface': surface || undefined,
        'data-qa-scroll-virtualized': virtualized ? 'true' : 'false',
        'data-qa-scroll-answer-id': answer?.id != null ? String(answer.id) : undefined,
    }
}
